import { createAsyncThunk, AnyAction, createSlice } from "@reduxjs/toolkit";
import { SubmerchantInitialStateDTO } from "./types";
import {
  AddSubmerchantList,
  DeleteSubmerchant,
  GetSubmerchantList,
  UpdateSubmerchantList,
} from "./integrations.request";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";

export const initialState: SubmerchantInitialStateDTO = {
  getSubmerchantLoading: false,
  getSubmerchantSuccess: false,
  getSubmerchantError: false,
  getSubmerchantData: null,
  deleteSubmerchantLoading: false,
  deleteSubmerchantSuccess: false,
  deleteSubmerchantError: false,
  saveSubmerchantLoading: false,
  saveSubmerchantSuccess: false,
  saveSubmerchantError: false,
};

export const getSubmerchantList = createAsyncThunk(
  "submerchant/getSubmerchantList",
  async (id: any, thunkAPI: any) => {
    return GetSubmerchantList(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const deleteSubmerchant = createAsyncThunk(
  "submerchant/deleteSubmerchant",
  async (body: any, thunkAPI: any) => {
    return DeleteSubmerchant(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const saveSubmerchant = createAsyncThunk(
  "submerchant/saveSubmerchant",
  async (body: any, thunkAPI: any) => {
    return AddSubmerchantList(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const updateSubmerchant = createAsyncThunk(
  "submerchant/updateSubmerchant",
  async (body: any, thunkAPI: any) => {
    return UpdateSubmerchantList(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const submerchantSlice = createSlice({
  name: "submerchant",
  initialState,
  reducers: {
    reset: () => initialState,
    resetDeleteSubmerchantSuccess: (state) => {
      state.deleteSubmerchantSuccess = false;
    },
    resetSaveSubmerchantSuccess: (state) => {
      state.saveSubmerchantSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSubmerchantList.pending, (state) => {
      state.getSubmerchantLoading = true;
      state.getSubmerchantSuccess = false;
      state.getSubmerchantError = false;
    });
    builder.addCase(
      getSubmerchantList.fulfilled,
      (state, action: AnyAction) => {
        state.getSubmerchantLoading = false;
        state.getSubmerchantSuccess = true;
        state.getSubmerchantError = false;
        state.getSubmerchantData = action?.payload;
      }
    );
    builder.addCase(getSubmerchantList.rejected, (state, action: AnyAction) => {
      state.getSubmerchantLoading = false;
      state.getSubmerchantSuccess = false;
      state.getSubmerchantError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(deleteSubmerchant.pending, (state) => {
      state.deleteSubmerchantLoading = true;
      state.deleteSubmerchantSuccess = false;
      state.deleteSubmerchantError = false;
    });
    builder.addCase(deleteSubmerchant.fulfilled, (state, action: AnyAction) => {
      state.deleteSubmerchantLoading = false;
      state.deleteSubmerchantSuccess = true;
      state.deleteSubmerchantError = false;
    });
    builder.addCase(deleteSubmerchant.rejected, (state, action: AnyAction) => {
      state.deleteSubmerchantLoading = false;
      state.deleteSubmerchantSuccess = false;
      state.deleteSubmerchantError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(saveSubmerchant.pending, (state) => {
      state.saveSubmerchantLoading = true;
      state.saveSubmerchantSuccess = false;
      state.saveSubmerchantError = false;
    });
    builder.addCase(saveSubmerchant.fulfilled, (state, action: AnyAction) => {
      state.saveSubmerchantLoading = false;
      state.saveSubmerchantSuccess = true;
      state.saveSubmerchantError = false;
    });
    builder.addCase(saveSubmerchant.rejected, (state, action: AnyAction) => {
      state.saveSubmerchantLoading = false;
      state.saveSubmerchantSuccess = false;
      state.saveSubmerchantError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(updateSubmerchant.pending, (state) => {
      state.saveSubmerchantLoading = true;
      state.saveSubmerchantSuccess = false;
      state.saveSubmerchantError = false;
    });
    builder.addCase(updateSubmerchant.fulfilled, (state, action: AnyAction) => {
      state.saveSubmerchantLoading = false;
      state.saveSubmerchantSuccess = true;
      state.saveSubmerchantError = false;
    });
    builder.addCase(updateSubmerchant.rejected, (state, action: AnyAction) => {
      state.saveSubmerchantLoading = false;
      state.saveSubmerchantSuccess = false;
      state.saveSubmerchantError =
        action?.error?.message || "Something went wrong";
    });
  },
});

export default submerchantSlice.reducer;
export const {
  reset,
  resetDeleteSubmerchantSuccess,
  resetSaveSubmerchantSuccess,
} = submerchantSlice.actions;
